// extracted by mini-css-extract-plugin
export default {"container":"Presentacion_container__EZiX2","title":"Presentacion_title__SS5GA","text":"Presentacion_text__kmdKW"};